export const FETCH_TAGS = "FETCH_TAGS";
export const SET_TAGS_DATA = "SET_TAGS_DATA";
